export default ({ $api }) => {
  $api.register('util', '/web/public/util', request => ({
    jobId(payload) {
      return request('POST', '/hello-soda', payload);
    },
  }));
};
